import { ModalFooter, type StackProps } from '@chakra-ui/react';

export type UiModalFooterProps = StackProps;

export const UiModalFooter = ModalFooter;
